export default __webpack_public_path__ + "static/media/stats-illustration.45a1619b.svg";